export default "__VITE_ASSET__f2ffeab2__"